// extracted by mini-css-extract-plugin
module.exports = {"resourceListFailedMessage":"resourceList_resourceListFailedMessage__Y8O9a"};